import { useMemo, useState } from 'react';

import type { IncidentListRow } from '@/features/shared/incidentListRow';
import { incidentMarker } from './markers';
import { IncidentListMapComponent, usePsapMapConfiguration } from './IncidentListMapComponent';
import { IncidentMarkerDetailTemplate } from './IncidentMarkerDetailTemplate';
import { PopupView } from './PopupView';

export type IncidentListMapProps = {
  incidents?: readonly IncidentListRow[] | null;
  disableControls?: boolean;
};

export function IncidentListMap({ incidents, disableControls = false }: IncidentListMapProps) {
  const mapConfiguration = usePsapMapConfiguration();

  const [center] = useState(() => mapConfiguration.defaultPosition);
  const [zoom] = useState(() => mapConfiguration.defaultZoom);

  const [incidentDetail, setIncidentDetail] = useState<IncidentListRow | null>(null);

  const effectiveMarkers = useMemo(
    () =>
      (incidents ?? [])
        .filter((incident) => incident.lastPosition != null)
        .map((incident) =>
          incidentMarker(incident.id, [incident.lastPosition!.latitude, incident.lastPosition!.longitude]),
        ),
    [incidents],
  );

  const onMarkerClicked = (markerId: string) => {
    setIncidentDetail(incidents?.find((incident) => incident.id === markerId) ?? null);
  };

  return (
    <IncidentListMapComponent
      center={center}
      zoom={zoom}
      items={effectiveMarkers}
      disableControls={disableControls}
      onMarkerClicked={onMarkerClicked}
      popupContent={
        <PopupView show={incidentDetail != null} onClose={() => setIncidentDetail(null)}>
          {incidentDetail != null && <IncidentMarkerDetailTemplate item={incidentDetail} />}
        </PopupView>
      }
    />
  );
}
